import { BookingAction } from "../contants/Modules.Action.Type";

export const BookingChangeHandler = (e, date) => (dispatch, getstate) => {
  let Booking = getstate().Booking.Booking;
  if (date) {
    Booking["Ddate"] = e;
  } else {
    if (e.target) {
      Booking[e.target.name] = e.target.value;
    } else {
      Booking["customer"] = e;
    }
  }
  dispatch({
    type: BookingAction.BOOKING_CHANGE_HANDLER,
    payload: { Booking },
  });
};

export const BookingAddParticular = (e) => (dispatch, getstate) => {
  let alreadyExists = false;
  const BookingData = getstate().Booking.Booking;
  const particular = BookingData.particulars.slice();
  particular.forEach((x) => {
    if (x.id === e.id && x.note === e.note) {
      alreadyExists = true;
      x.qty = x.qty + e.qty;
      x.free = x.free + e.free;
      x.netAmt = x.netAmt + e.netAmt;
      x.taxAmt = x.taxAmt + e.taxAmt;
    }
  });
  if (!alreadyExists && e.product) {
    let newdata = {
      name: e.product,
      id: e.id,
      qty: e.qty,
      free: e.free,
      rate: e.rate,
      tax: e.tax,
      taxAmt: e.taxAmt,
      netAmt: e.netAmt,
      note: e.note || "",
    };
    particular.push({ ...newdata });
  }
  const Booking = BookingData;
  Booking.particulars = particular;
  dispatch({
    type: BookingAction.BOOKING_ADD_PARTICULAR,
    payload: { Booking },
  });
  dispatch(BookingCalculation());
};

export const removeBookingParticular = (e) => (dispatch, getstate) => {
  const BookingData = getstate().Booking.Booking;
  let Particular = BookingData.particulars.slice();
  const selectProduct = Particular.find(
    (items) => items.id === e.id && items.note === e.note
  );
  const index = Particular.indexOf(selectProduct);
  Particular.splice(index, 1);
  const Booking = BookingData;
  Booking.particulars = Particular;
  dispatch({
    type: BookingAction.REMOVE_BOOKING_PARTICULAR,
    payload: { Booking },
  });
  dispatch(BookingCalculation());
};

export const BookingCalculation = () => (dispatch, getstate) => {
  const BookingData = getstate().Booking.Booking;
  const netamount = parseFloat(
    BookingData.particulars.reduce((sum, i) => (sum += i.netAmt), 0)
  );
  const TaxAmount = 0;
  const Booking = BookingData;
  Booking.netAmount = netamount;
  Booking.taxAmount = TaxAmount;
  Booking.grandTotal =
    netamount +
    TaxAmount +
    parseFloat(BookingData.delivery) -
    parseFloat(BookingData.advance);
  dispatch({
    type: BookingAction.BOOKING_TOTAL_CALCULATION,
    payload: { Booking },
  });
};

export const BookingSetToDefault = () => (dispatch) => {
  const Booking = {
    customer: [],
    Ddate: new Date(),
    type: "storepick",
    payment: "COD",
    Daddress: "",
    Dcontact: "",
    landmark: "",
    sameAsOrder: true,
    particulars: [],
    netAmount: 0,
    delivery: 0,
    advance: 0,
    tax: 0,
    taxAmount: 0,
    grandTotal: 0,
    remark: "",
    docs: [],
  };
  dispatch({
    type: BookingAction.BOOKING_SET_TO_DEFAULT,
    payload: { Booking },
  });
};
